import { render, staticRenderFns } from "./yanse.vue?vue&type=template&id=16688298&"
import script from "./yanse.vue?vue&type=script&lang=ts&"
export * from "./yanse.vue?vue&type=script&lang=ts&"
import style0 from "./yanse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports